/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {FormElementNumberTypes, FormElementType} from 'app/entities/enums';
import {Type} from 'class-transformer';

export class FormElementNumber extends FormElement {
  type: FormElementType = 'number';

  @Type(() => FormElementNumberConfiguration)
  configuration?: FormElementNumberConfiguration = new FormElementNumberConfiguration();
}

export class FormElementNumberConfiguration extends FormElementConfiguration {
  type?: FormElementNumberTypes = 'number';
  mask?: string = null;
  clearable = true;
  minLength?: number = null;
  maxLength?: number = null;
  minValue?: number = null;
  maxValue?: number = null;
}
